export function mapToArray(map) {
    return Array.from(map).reduce((acc, cur) => {
        if (cur[1] && cur[1].length > 0) {
            return [...acc, { Key: cur[0], Text: cur[1] }];
        }
        return acc;
    }, []);
}
export default { mapToArray };
//# sourceMappingURL=index.js.map